export default __webpack_public_path__ + "static/media/flag-united-kingdom.37c072bd.svg";